import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {ProcedureTypedValue} from 'notebook/tables/typed-values/TypedValueTypes';

import {ProcedureSearchQueryResponse} from './ProcedureSearch';

/**
 * Transforms the ProcedureSearchInput's response shape into a {@link ProcedureTypedValue}.
 */
export function toProcedureTypedValueFromSearchResponse(
  procedures: Array<ProcedureSearchQueryResponse>
): ProcedureTypedValue {
  return {
    type: BaseTypedValueType.PROCEDURE,
    procedures: procedures.map(
      (procedure) =>
        ({
          id: procedure.id,
          name: procedure.name,
        }) satisfies ProcedureTypedValue['procedures'][number]
    ),
  };
}

/**
 * Coerces the given {@link TypedValue} into a shape compatible with ProcedureSearchInput.
 *
 * If `typedValue` is a {@link ProcedureTypedValue}, extracts the values.
 * Otherwise, an empty list is returned.
 */
export function toProcedureSearchResponseFromTypedValue(
  typedValue: TypedValue | null | undefined
): Array<ProcedureSearchQueryResponse> {
  return typedValue?.type === BaseTypedValueType.PROCEDURE ? typedValue.procedures : [];
}
